/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : CONTENT TYPE INDICATOR : STYLES --------------- ++++++++++ */
export default theme => ({
	contentindicator: {
		whiteSpace: 'nowrap',
		'&.type-sort': {
			'& .contenttype': {
				cursor: 'pointer'
			}
		},
        '&.greyOut-true':{
            pointerEvents: 'none',
            filter: 'grayScale(1)',
            opacity: .4
        }
	}
});
